import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { getEventDetailQueryKey, getEventsQueryKey } from '../queries';

export const useInvalidateQueriesOnEventFeedbackFinished = () => {
  const queryClient = useQueryClient();

  return useCallback(
    async ({ id }: { id: string }) => {
      await queryClient.invalidateQueries({ queryKey: getEventDetailQueryKey({ id }) });
      await queryClient.invalidateQueries({ queryKey: getEventsQueryKey({}) });
    },
    [queryClient],
  );
};
